<template>
  <div v-if="showComponent"
       :title="qaAble ? showIfHasPermission?.toString() : null"
       :key="componentRefresh">
    <slot/>
  </div>
</template>

<script>
import checkPermissions from '../../mixins/checkPermissions';

export default {
  name: 'ks-tabs',
  mixins: [checkPermissions],
  computed: {
    data_provider_ref() {
      return this.$parent.data_provider_ref ? this.$parent.data_provider_ref : {};
    },
    dataProvider() {
      return this.$parent.dataProvider ? this.$parent.dataProvider : null;
    },
    type() {
      return this.$parent.type ? this.$parent.type : null;
    },
    qaAble: {
      get: () => {
        return app.store.state.ks_app.global_data.qaAble;
      }
    }
  },
  methods: {
    openFirstTab() {
      $('.nav-tabs a:first').tab('show');
    },
    openLastTab() {
      $('.nav-tabs a:last').tab('show');
    },
    openTab(id) {
      $(`.nav-tabs a[href="#${id}"]`).tab('show');
    }
  }
}
</script>
